<div class="colab-manager-content-component colab-autoupdate fade-in-animation">

  <div class="row" style="margin: 0;">
    <div class="col-md-12 col-sm-12 no-padding ">

      <h1 class="no-margin">Campanhas básicas</h1>
      <p>
        Os materiais a seguir são uteis pois apresentam o que é a Allya, seus principais benefícios e como utilizar. Devem ser divulgados no lançamento da plataforma em cada uma de suas unidades para que todos conheçam este benefício.
      </p>
      <p>Os materiais estão disponíveis nos seguintes formatos: E-mail, Murais, TV Corporativas e com POST para comunicação interna.</p>
      <p>Todos contêm <strong>Arquivos editáveis</strong> (abertos para alterações) e <strong>Não editáveis</strong> (já prontos para sua utilização).</p>

      <div id="basic-campaign" class="area-to-overlay">

        <table class="table table-striped">
          <tbody>
            <tr *ngFor="let campaign of basicCampaigns; let i = index">
              <td><img style="width: 51px;" src="{{ campaign.image }}" /></td>
              <td>{{ campaign.title }}</td>
              <td>
                <button *ngIf="campaign.files.edited" class="btn-orange-contrast btn-editable" (click)="trackingEvent(campaign.title, 'editable'); downloadFile(campaign.files.edited)"></button>
                <button *ngIf="campaign.files.notEdited" class="btn-orange btn-non-editable" (click)="trackingEvent(campaign.title, 'non-editable'); downloadFile(campaign.files.notEdited)"></button>
              </td>
            </tr>
          </tbody>
        </table>

        <small *ngIf="basicCampaigns && basicCampaigns.length === 0">Nenhuma campanha básica</small>

      </div>

      <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

    </div>
  </div>
</div>
